import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const quickAddToCart = node.querySelector('[data-quick-add-to-cart-button]');
  const productToAdd = node.dataset.productId;

  /**
   * Functions
   */
  const handleAddToCart = async (e) => {
    e.preventDefault();

    const itemToAdd = [
      {
        id: Number(productToAdd),
        quantity: 1,
      },
    ];
    await addToCart(itemToAdd);

    // Emit event to open cart
    document.dispatchEvent(new CustomEvent('cart:open'));
  };

  /**
   * Init
   */
  const init = () => {
    quickAddToCart.addEventListener('click', handleAddToCart);
  };

  init();
};
